/**
 * 配置 测试环境 和 正式环境 的切换
 */

let apiUrl = 'https://api.z7zba.com';
let routerMode = 'history'; //hash , history 

// console.log(process.env.NODE_ENV)

if(process.env.NODE_ENV == 'development') {
    // apiUrl = 'http://api.blog.z7zba.com';
}
else if(process.env.NODE_ENV == 'development') {
}

export {
    apiUrl,
    routerMode
}